export default [
  'INIT',
  'LEAVE',
  'FETCH_SUCCESS',
  'FETCH_FAILURE',
  'FETCH_SETTINGS_SUCCESS',
  'FETCH_SETTINGS_FAILURE',
  'UPDATE_SPEAKERS',
  'SAVE',
  'SAVING',
  'SAVED_SUCCESS',
  'SAVED_FAILURE',
  'RESET_STORE_DATA',
  'OK_CLICK_CRUD_MODAL',
  'CANCEL_CLICK_CRUD_MODAL',
  'OPEN_CRUD_MODAL',
  'CLOSE_CRUD_MODAL',
  'SEND_INVITE',
  'SEND_INVITE_LOADING',
  'SEND_INVITE_IDLE',
  'SPEAKER_ADDED_SUCCESS',
  'SPEAKER_INVITED_SUCCESS',
  'REORDER',
  'UPDATE_ORDER',
  'REFETCH',
]
